"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bus_config = require("@/api/cfg/bus_config");
var _WxWorkCfgIndex = _interopRequireDefault(require("@/views/cfg/WxWorkCfgIndex.vue"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'sso_cfg',
  components: {
    WxWorkConfigIndex: _WxWorkCfgIndex.default
  },
  data: function data() {
    return {
      ssoCfg: null
    };
  },
  created: function created() {
    this.getSsoCfg();
  },
  methods: {
    getSsoCfg: function getSsoCfg() {
      var _this = this;
      (0, _bus_config.querySsoCfg)().then(function (res) {
        var data = res.data;
        if (data) {
          _this.ssoCfg = data.cfgValue;
        }
      });
    }
  }
};